import React from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { SettingsProvider } from "utils/settingsContext";
import { FraudCheckProvider } from "utils/fraudCheckContext";
import { TOSProvider } from "components/JustInTimeTOS";
import defaultQueryClient from "api/queryClient";

/**
 * <PostAuthProviders /> contains providers we only want to surface after the widget has been
 * successfully authenticated in <AppAuth />
 * @param {Object} props
 * @param {JSX.Element|JSX.Element[]} props.children
 * @param {import('@tanstack/react-query').QueryClient} [props.queryClient] - Optional. Defaults to
 * the module singleton. Tests pass an isolated client here rather than nesting a second
 * QueryClientProvider inside this one, which would split the cache: <TOSProvider /> owns the ToS
 * sign mutation and would write to this client while components below read from the inner one.
 */
export const PostAuthProviders = ({ children, queryClient = defaultQueryClient }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <TOSProvider>
        <SettingsProvider>
          <FraudCheckProvider>{children}</FraudCheckProvider>
        </SettingsProvider>
      </TOSProvider>
    </QueryClientProvider>
  );
};
